import React, { createContext, useState } from 'react';

// Creamos el contexto para el modo oscuro
export const DisplaySettingsContext = createContext({});

const DisplaySettingsProvider = ({ children }) => {

  const getCookie = (name) => {
    var cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
        var cookie = cookies[i].trim();
        if (cookie.startsWith(name + '=')) {
            return cookie.substring(name.length + 1);
        }
    }
    return null;
  };

  const setCookie = (name, value) => {
    let domain = window.location.hostname;
    const domainSplit = domain.split('.');
    const isHttps = window.location.protocol === 'https:';

    // Solo aplicar dominio personalizado si es HTTPS (producción)
    let cookieString = `${name}=${value}; expires=${new Date(
      Date.now() + 5 * 365 * 24 * 60 * 60 * 1000
    ).toUTCString()}; path=/`;

    if (isHttps) {
      // Para producción (HTTPS), usar el dominio principal (xxx.com)
      // Si tenemos empresa.xxx.com, tomamos xxx.com
      if (domainSplit.length >= 2) {
        domain = domainSplit.slice(-2).join('.');
      }
      cookieString += `; domain=${domain}; Secure; SameSite=Strict`;
    }

    document.cookie = cookieString;
  };

  // Estado para controlar el modo oscuro
  const [darkMode, setDarkMode] = useState(() => {
    // Obtener el valor del modo oscuro del Local Storage, o predeterminado a true si no existe
    const storedDarkMode = getCookie('dark_mode')
    return (storedDarkMode === 'true');
  });

  const [fontSizeSetting , setFontSizeSetting] = useState(()=>{
    return parseInt(getCookie('font_size') || 0)
  })

  // Función para cambiar el modo oscuro
  const toggleDarkMode = () => {
    setDarkMode(prevMode => {
      const newMode = !prevMode;
      setCookie('dark_mode',newMode)
      return newMode;
  });
  };



  // Pasamos el estado y la función de cambio como valor del proveedor
  return (
    <DisplaySettingsContext.Provider value={{ darkMode, toggleDarkMode, fontSizeSetting, setFontSizeSetting }}>
      {children}
    </DisplaySettingsContext.Provider>
  );
};

export default DisplaySettingsProvider;
